import { notificationInAppState, preferenceState, loginProfileState, hostMatchmakingState } from '../../stores/shared';
import { NotificationMessageType, websocket } from '@playcastdotio/Messaging';
import { sendMessage } from '../realtime';
import { serviceContainer } from '../../../services/ServiceContainer';

export const notifyStreamStarting = () => {
  notificationInAppState.updateState({
    notification: {
      title: 'Session starting',
      message: 'A match has been found for your computer.',
      type: 'info',
      timeoutTime: 10000,
    },
  });


  // const outboundMessage = websocket.generators.notification(NotificationMessageType.NOTIFICATION_SESSION_STARTED, {});
  // sendMessage(outboundMessage);
};

export const notifyStreamEnded = () => {
  notificationInAppState.updateState({
    notification: {
      title: 'Session ended',
      message: 'The session has ended.',
      type: 'warning',
      timeoutTime: 10000,
    },
  });

  // const outboundMessage = websocket.generators.notification(NotificationMessageType.NOTIFICATION_SESSION_STOPPED, {});
  // sendMessage(outboundMessage);
};

export const notifyPavilionModeEnabled = () => {
  notificationInAppState.updateState({
    notification: {
      title: 'Pavilion mode enabled',
      message: 'You are now in the matchmaking pool',
      type: 'info',
      timeoutTime: 10000,
    },
  });

  serviceContainer.analyticsManager.sendHostEnteredMatchmakingPoolEvent();

  try {
    const hostModeNotification = websocket.generators.notification(NotificationMessageType.NOTIFICATION_HOST_MODE_ENTERED, {
      hostModeEmail: preferenceState.currentState.email.hostMode,
      hostModeSms: preferenceState.currentState.phone.hostMode,
    });
    sendMessage(hostModeNotification);
    console.log('Host mode entered notification sent - server will handle email/SMS based on preferences');
  } catch (error) {
    console.error('Failed to send host mode entered notification:', error);
  }
};

export const notifyPavilionModeDisabled = () => {
  notificationInAppState.updateState({
    notification: {
      title: 'Pavilion mode disabled',
      message: 'You are no longer in the matchmaking pool',
      type: 'warning',
      timeoutTime: 10000,
    },
  });

  serviceContainer.analyticsManager.sendHostExitedMatchmakingPoolEvent();

  try {
    const hostModeNotification = websocket.generators.notification(NotificationMessageType.NOTIFICATION_HOST_MODE_EXITED, {
      hostModeEmail: preferenceState.currentState.email.hostMode,
      hostModeSms: preferenceState.currentState.phone.hostMode,
    });
    sendMessage(hostModeNotification);
    console.log('Host mode exited notification sent - server will handle email/SMS based on preferences');
  } catch (error) {
    console.error('Failed to send host mode exited notification:', error);
  }
};

export const notifyPlayerInstall = () => {
  // Never send install emails in guest mode (temporary anonymous accounts)
  if (hostMatchmakingState.currentState.guestAccount) {
    console.log('Skipping install email notification - guest mode enabled');
    return;
  }

  const INSTALL_EMAIL_SENT_KEY = 'playcast-install-email-sent';

  if (localStorage.getItem(INSTALL_EMAIL_SENT_KEY) === 'true') {
    console.log('Install email already sent (checked localStorage), skipping notification');
    return;
  }

  const sendInstallEmail = (email: string) => {
    try {
      const installNotification = websocket.generators.notification(NotificationMessageType.NOTIFICATION_PLAYER_INSTALL, {});
      sendMessage(installNotification);
      serviceContainer.analyticsManager.sendInstallEmailSentEvent(email);
      localStorage.setItem(INSTALL_EMAIL_SENT_KEY, 'true');
      console.log('Player install notification sent and marked in localStorage');
    } catch (error) {
      console.error('Failed to send player install notification:', error);
    }
  };

  const email = loginProfileState.currentState.email;

  if (email) {
    // Email already available — fire immediately
    sendInstallEmail(email);
  } else {
    // Email not yet populated — wait for it on a one-time listener
    console.log('[notifyPlayerInstall] Email not yet available, waiting for loginProfileState...');
    const listener = loginProfileState.addListener((state) => {
      if (state.email) {
        loginProfileState.removeListener(listener);
        // Re-check the dedup key in case another path sent it while we were waiting
        if (localStorage.getItem(INSTALL_EMAIL_SENT_KEY) === 'true') return;
        sendInstallEmail(state.email);
      }
    });
  }
};
